import React from 'react';
import { Box } from '@mui/material';
import { OpeningHoursApi } from 'common/types';
import { useTranslation } from 'services/localization';
import { getDayTypeTranslation } from 'common/utils/translations';

interface Props {
	openingHours: OpeningHoursApi;
}
const OpeningHoursSummary = (props: Props) => {
	const { t } = useTranslation();

	return (
		<Box>
			{props.openingHours.defaultTimes.map((time, idx) => (
				<Box
					key={idx}
					width={300}
					maxWidth="100%"
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					pb={1}
				>
					<Box pr={2}>{getDayTypeTranslation(time.dayType, t)}</Box>
					<Box>
						{time.isClosed ? t('common:times.closed') : `${time.openTime} - ${time.closeTime}`}
					</Box>
				</Box>
			))}
		</Box>
	);
};

export default OpeningHoursSummary;
